import React, { Component } from 'react';
import ReactPlayer from 'react-player';

// import styles from './index.module.less';

export interface VideoProps {
  datasourceCustom: [], // 数据源
  associateDataSource:[], // 关联数据源
  url: string, // 视频地址
  light:string, // 封面图片
  autoPlay: boolean, // 自动播放
  controls: boolean, // 控制器
  loop: boolean, // 循环
  muted: boolean, // 静音
  playbackRate: number, // 播放倍速
  onPlay: object, // 播放事件
  onPause: object, // 暂停事件
  onEnded: object, // 播放结束事件
  onScreenFull: object, // 全屏事件
  onReady: object, // 加载完成时事件
}

export default class Video extends Component<VideoProps> {
  render () {
    const {
      fieldid,
      datasourceCustom = [],
      associateDataSource = [],
      url = 'https://mkfs.yybip.com/static/videos/1584520624676561.mp4',
      light = 'https://mkfs.yybip.com/static/img/tabbanner/%E6%99%BA%E8%83%BD%E5%88%B6%E9%80%A0.jpg',
      autoPlay = false,
      controls = true,
      loop = false,
      muted = false,
      playbackRate = 1,
      visible = true,
      ...args
    } = this.props;
    const config = {
      datasourceCustom,
      associateDataSource,
      url,
      light,
      autoPlay,
      controls,
      loop,
      muted,
      playbackRate,
      ...args
    }
    fieldid && (config.fieldid = fieldid)
    if (!visible) {
      return <div></div>
    }
    if (datasourceCustom.length > 0) {
      const key = datasourceCustom[1];
      config.url = args[key] || ''
    }
    return (<ReactPlayer {...config} />);
  }
}
